import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SupportUsersModel } from '@models/support-users.model';
import { api } from '@consts/url.const';

@Injectable({
  providedIn: 'root',
})
export class SupportUsersService {
  private readonly http = inject(HttpClient);

  public getUsers(
    page: number,
    perPage: number,
    filters: SupportUsersModel.Filters,
  ): Observable<SupportUsersModel.SupportUserDocument[]> {
    let params = new HttpParams()
      .set('page', String(page))
      .set('size', String(100));

    const query = filters.query?.trim();
    if (query) {
      params = params.set('query', query);
    }

    (filters.roles ?? []).forEach((role) => {
      params = params.append('roles', role);
    });

    return this.http.get<SupportUsersModel.SupportUserDocument[]>(
      api.users.getSupportUsers,
      { params },
    );
  }
}
